<h3>{{ listTitle ? listTitle : 'Unknown dashboard' }}</h3>
<div class="list_cover">
    <div class="table table-striped table-hover operations list" [class.hide-status]="hideStatusColumn">
        <div class="operation-header">
            <div class="customer">Customer</div>
            <div class="TC job">Project No.</div>
            <div class="TC task">Task No.</div>
            <div class="description-col description">Description</div>
            <div class="TC start">Start time</div>
            <div class="TC end">End time</div>
            <div class="TC estimation">Estimation</div>
            <div class="TC operators">Operators</div>
            <div class="TC notes">Notes</div>
            <div class="TC extra">Extra</div>
            <div class="TC responsible">Responsible</div>
            <!--<div class="TC status" *ngIf="userCan.updateOperationStatus(listType) && !hideStatusColumn">Status</div>-->
            <div *ngIf="userCan.runOperationActions(listType)"
                 class="TC actions"
                 [ngClass]="{
                        'extend' : userCan.acceptOperation(listType)
                                    && userCan.editOperation(listType)
                                    && userCan.copyOperation(listType)
                                    && userCan.deleteOperation(listType)
                    }">
                Actions
            </div>
        </div>
        <div class="operation-rows">
            <div *ngFor="let operation of sortedOperations" class="operation-main operation {{ operation.status }}">
                <div class="card-group card-meta">
                    <div class="TC customer"
                         (click)="editOperation(operation.id)">
                        {{ operation.task.job.customer.name }}
                    </div>
                    <div class="TC job"
                         title="{{ operation.task.job.description }}"
                         (click)="editOperation(operation.id)">
                        {{
                        operation.task.job.externalId
                        ? operation.task.job.externalId
                        : " - - "
                        }}
                    </div>
                    <div class="TC task"
                         title="{{ operation.task.description }}"
                         (click)="editOperation(operation.id)">
                        {{
                        operation.task.externalId
                        ? operation.task.externalId
                        : " - - "
                        }}
                        <div class="TC operation-task-description">
                            {{ operation.task.description }}
                        </div>
                    </div>
                    <div class="TC start" (click)="editOperation(operation.id)">
                        {{ operation.startDateTime| tbaDate }}
                    </div>
                    <div class="TC end" (click)="editOperation(operation.id)">
                        {{ operation.endDateTime| tbaDate }}
                    </div>
                    <div class="TC estimation" (click)="editOperation(operation.id)">
                        {{ operation.estimatedTime | durationFormat }}
                    </div>
                    <div class="operators" (click)="editOperation(operation.id)">
                        <div *ngFor="let worker of operation.involvedWorkers; let isLast=last">
                            <span class="involvedWorker NW">{{ worker.name }}{{ isLast ? '' : ', ' }}</span>
                        </div>
                    </div>
                   <!-- <div class="TC " *ngIf="userCan.updateOperationStatus(listType) && !hideStatusColumn">
                        <i *ngIf="operation.status == 'Active'" class="icon status incompleted fa fa-square-minus" (click)="updateOperationStatus(operation.id, operationStatuses.Completed)"></i>
                        <i *ngIf="operation.status == 'Completed'" class="icon status completed fa fa-check-square" (click)="updateOperationStatus(operation.id, operationStatuses.Active)"></i>
                    </div>-->
                </div>
                <div class="card-group card-description">
                    <div (click)="editOperation(operation.id)">
                        <!--[ngbTooltip]="operation.description" tooltipClass="custom-tooltip" container="body"-->
                        <div class="description nl2br description-col">{{ operation.description }}</div>
                        <div *ngIf="operation.important" class="important">
                            {{ operation.important }}
                        </div>
                    </div>
                </div>
                <div class="card-group card-extra">
                    <div (click)="editOperation(operation.id)" class="notes">
                        {{ operation.notes }}
                        <div class="vehicles" *ngIf="operation.involvedMachines?.length">
                            <h6>Vehicles:</h6>
                            <div class="details flex NW" *ngFor="let vehicle of operation.involvedMachines; let isLast=last">
                                <span> {{ vehicle.subType }} </span>
                                <span> {{ vehicle.capacityText }} </span>
                                <span> ({{ vehicle.externalId }}){{ isLast ? '' : ',' }} </span>
                            </div>
                        </div>
                        <div class="location" *ngIf="operation.location?.id && operation.location?.name != otherLocationName">
                            <h6>Location:</h6>
                            <div class="details"> {{ operation.location.name }} </div>
                        </div>
                    </div>
                    <div class="TC extra">
                        <ng-container *ngIf="!operation.involvedMachines?.length; else vehiclesIcon">
                            <button *ngIf="userCan.manageOperationResources(listType)"
                                    type="button"
                                    class="btn btn-outline-success add_extra"
                                    (click)="operationResources(operation.id, 'vehicles')">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </ng-container>
                        <ng-template #vehiclesIcon>
                            <ng-template #vehiclesList>
                                <div *ngFor="let vehicle of operation.involvedMachines">{{vehicle.name}}</div>
                            </ng-template>
                            <img class="icon vehicle" src="../../assets/terminal.svg"
                                 (click)="operationResources(operation.id, 'vehicles')"
                                 [ngbTooltip]="vehiclesList"
                                 tooltipClass="tooltip green"
                                 [ngClass]="operation.status == 'Completed'
                                ? 'disabled'
                                : 'active'
                            ">
                        </ng-template>
                        <button *ngIf="operation.attachedFiles?.length" class="btn" (click)="operationResources(operation.id, 'files')">
                            <i class="icon files fa-solid fa-paperclip" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="operation.location?.id && operation.location?.name != otherLocationName" class="btn">
                            <i class="icon location fa-solid fa-location-dot"
                               aria-hidden="true"
                               [ngbTooltip]="operation.location?.name"
                               tooltipClass="tooltip green"></i>
                        </button>
                    </div>
                    <div class="TC responsible" (click)="editOperation(operation.id)">
                        {{ operation.responsiblePerson.name }}
                    </div>
                    <div class="TC actions" *ngIf="userCan.runOperationActions(listType)">
                        <div class="container flex NW TJ VM">
                            <div class="cover flex TC VM " *ngIf="userCan.updateOperationStatus(listType) && !hideStatusColumn">
                                <i *ngIf="operation.status == 'Active'" class="icon status incompleted fa fa-check-square" (click)="updateOperationStatus(operation.id, operationStatuses.Completed)"></i>
                                <i *ngIf="operation.status == 'Active' && canRejectOperation" class="icon status delete fa fa-times" (click)="rejectOperation(operation.id)"></i>
                                <i *ngIf="operation.status == 'Completed'" class="icon status completed fa fa-check-square" (click)="updateOperationStatus(operation.id, operationStatuses.Active)"></i>
                            </div>
                            <div *ngIf="userCan.acceptOperation(this.listType)" class="cover flex TC VM">
                                <i class="icon accept fa fa-check" (click)="acceptOperation(operation.id)"></i>
                            </div>
                            <div *ngIf="userCan.editOperation(this.listType)" class="cover flex TC VM">
                                <i class="icon edit fa fa-edit" (click)="editOperation(operation.id)"></i>
                            </div>
                            <div *ngIf="userCan.copyOperation(listType)" class="cover flex TC VM">
                                <i *ngIf="userCan.copyOperation(listType)" class="icon copy fa fa-clone" (click)="copyOperation(operation.id)"></i>
                            </div>
                            <div *ngIf="userCan.deleteOperation(listType)" class="cover flex TC VM">
                                <fa-icon [icon]="faDelete" class="icon delete fa-delete" (click)="removeOperation(operation)"></fa-icon>
                            </div>
                            <div class="cover flex TC VM">
                                <span class="comment-icon-container">
                                    <i class="icon fa-solid fa-comments"
                                       (click)="openLogbook(operation)">
                                    </i>
                                    <span *ngIf="operation.hasComments"
                                          class="notification-dot"
                                          [class.unread-dot]="operation.hasUnreadComments"
                                          [class.read-dot]="!operation.hasUnreadComments && operation.hasComments">
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
